// ============================================================
//  DATE STATICE — IMPERFECT HOUSE
//  Acest fisier inlocuieste baza de date. Editeaza-l liber:
//  - preturi, descrieri camere (UNITS)
//  - recenzii (REVIEWS)
//  - atractii (ATTRACTIONS)
//  - date de contact (CONFIG)
//  - perioade ocupate (BOOKED) — format: "AAAA-LL-ZZ/AAAA-LL-ZZ"
//    (check-in / check-out; ziua de check-out ramane libera)
// ============================================================

export const CONFIG = {
  "whatsapp": "40721663181",
  "phone_display": "+40 721 663 181",
  "email": "guiumihai@yahoo.com",
  "address": "Strada Ion Luca Caragiale nr. 127, Râșnov 505400, România",
  "checkin": "15:00 – 22:00",
  "checkout": "până la 11:00",
  "score_general": "9,6",
  "score_cleanliness": "9,9",
  "score_comfort": "9,8",
  "score_location": "9,6",
  "score_host": "9,7",
  "score_value": "9,6",
  "reviews_count": "62",
  "house_lat": "45.5907",
  "house_lng": "25.4612",
  "social_facebook": "https://www.facebook.com/",
  "social_instagram": "https://www.instagram.com/imperfect_house_rasnov/",
  "social_tiktok": "https://www.tiktok.com/",
  "notification_email": "guiumihai@yahoo.com"
};

export const UNITS = [
  {
    "id": "room-crem",
    "name_ro": "Camera Crem",
    "name_en": "Cream Room",
    "name_it": "Camera Crema",
    "slug": "camera-crem",
    "type": "room",
    "base_price": 70,
    "capacity_adults": 2,
    "capacity_children": 1,
    "size": "20 m²",
    "floor_ro": "Parter",
    "floor_en": "Ground floor",
    "floor_it": "Piano terra",
    "bed": "180 × 200 cm",
    "shower": "cca. 100 × 170 cm",
    "view_ro": "Grădină",
    "view_en": "Garden",
    "view_it": "Giardino",
    "image": "/assets/bedroom.jpg",
    "active": true,
    "sort_order": 1,
    "desc_ro": "Simplă, luminoasă, accesibilă — și nu-ți cere să urci scări după o zi prin munți. Pat 180 × 200 cm, baie proprie, duș generos.",
    "desc_en": "Simple, bright, accessible — and it doesn't ask you to climb stairs after a day in the mountains. 180 × 200 cm bed, private bathroom, generous shower.",
    "desc_it": "Semplice, luminosa, accessibile — e non ti chiede di salire le scale dopo una giornata in montagna. Letto 180 × 200 cm, bagno privato, doccia ampia.",
    "saying_ro": "Camera nu-i cât Versailles-ul. Dar nici până la baie nu mergi cu GPS-ul.",
    "saying_en": "The room is no Versailles. But you won't need GPS to find the bathroom either.",
    "saying_it": "La camera non è Versailles. Ma nemmeno per il bagno serve il GPS.",
    "desc_de": "Einfach, hell, ebenerdig — und keine Treppe nach einem Tag in den Bergen. Bett 180 × 200 cm, eigenes Bad, großzügige Dusche.",
    "desc_he": "פשוט, מואר, נגיש — בלי מדרגות אחרי יום בהרים. מיטה 180 × 200 ס\"מ, חדר רחצה פרטי, מקלחת מרווחת.",
    "desc_pl": "Prosty, jasny, na parterze — bez schodów po dniu w górach. Łóżko 180 × 200 cm, własna łazienka, przestronny prysznic.",
    "saying_de": "Das Zimmer ist kein Versailles. Aber bis zum Bad brauchst du auch kein GPS.",
    "saying_he": "החדר הוא לא ורסאי. אבל גם לשירותים לא צריך GPS.",
    "saying_pl": "Pokój to nie Wersal. Ale do łazienki też nie potrzebujesz GPS-a.",
    "floor_de": "Erdgeschoss",
    "floor_he": "קומת קרקע",
    "floor_pl": "Parter",
    "view_de": "Garten",
    "view_he": "גינה",
    "view_pl": "Ogród"
  },
  {
    "id": "room-salvie",
    "name_ro": "Camera Salvie",
    "name_en": "Sage Room",
    "name_it": "Camera Salvia",
    "slug": "camera-salvie",
    "type": "room",
    "base_price": 70,
    "capacity_adults": 2,
    "capacity_children": 1,
    "size": "20 m²",
    "floor_ro": "Parter",
    "floor_en": "Ground floor",
    "floor_it": "Piano terra",
    "bed": "180 × 200 cm",
    "shower": "cca. 100 × 170 cm",
    "view_ro": "Munte",
    "view_en": "Mountain",
    "view_it": "Montagna",
    "image": "/assets/bedroom.jpg",
    "active": true,
    "sort_order": 2,
    "desc_ro": "Relaxată și calmă, potrivită pentru oamenii care au venit să mai uite puțin de notificări. Pat 180 × 200 cm, baie proprie.",
    "desc_en": "Relaxed and calm, made for people who came here to forget about notifications for a while. 180 × 200 cm bed, private bathroom.",
    "desc_it": "Rilassata e calma, perfetta per chi è venuto a dimenticare le notifiche per un po'. Letto 180 × 200 cm, bagno privato.",
    "saying_ro": "Salvia cică liniștește. Noi am pus și pat king-size, să nu riscăm.",
    "saying_en": "Sage is said to be calming. We added a king-size bed too, just to be safe.",
    "saying_it": "La salvia, si dice, calma. Noi abbiamo aggiunto anche un letto king-size, per non rischiare.",
    "desc_de": "Ruhig und gelassen — für Menschen, die hierher kommen, um die Benachrichtigungen eine Weile zu vergessen. Bett 180 × 200 cm, eigenes Bad.",
    "desc_he": "רגוע ושליו — בשביל אנשים שבאו לשכוח קצת מההתראות. מיטה 180 × 200 ס\"מ, חדר רחצה פרטי.",
    "desc_pl": "Spokojny i wyciszony — dla ludzi, którzy przyjechali na chwilę zapomnieć o powiadomieniach. Łóżko 180 × 200 cm, własna łazienka.",
    "saying_de": "Salbei soll beruhigen. Wir haben zur Sicherheit noch ein King-Size-Bett dazugestellt.",
    "saying_he": "אומרים שמרווה מרגיעה. אנחנו שמנו גם מיטת קינג-סייז, שלא נסתכן.",
    "saying_pl": "Podobno szałwia uspokaja. My dodaliśmy też łóżko king-size, żeby nie ryzykować.",
    "floor_de": "Erdgeschoss",
    "floor_he": "קומת קרקע",
    "floor_pl": "Parter",
    "view_de": "Berge",
    "view_he": "הרים",
    "view_pl": "Góry"
  },
  {
    "id": "room-teracota",
    "name_ro": "Camera Teracotă",
    "name_en": "Terracotta Room",
    "name_it": "Camera Terracotta",
    "slug": "camera-teracota",
    "type": "room",
    "base_price": 70,
    "capacity_adults": 2,
    "capacity_children": 1,
    "size": "30 m²",
    "floor_ro": "Mansardă",
    "floor_en": "Attic",
    "floor_it": "Mansarda",
    "bed": "180 × 200 cm",
    "shower": "cca. 100 × 170 cm",
    "view_ro": "Curte",
    "view_en": "Courtyard",
    "view_it": "Cortile",
    "image": "/assets/bedroom.jpg",
    "active": true,
    "sort_order": 3,
    "desc_ro": "Spațiu, lumină și mansardă cât să începi să te întrebi dacă nu cumva ai rezervat un mic apartament. Pat 180 × 200 cm, duș generos.",
    "desc_en": "Space, light and an attic generous enough to make you wonder if you accidentally booked a small apartment. 180 × 200 cm bed, generous shower.",
    "desc_it": "Spazio, luce e una mansarda così generosa da farti chiedere se non hai prenotato un piccolo appartamento. Letto 180 × 200 cm, doccia ampia.",
    "saying_ro": "Dacă într-o cameră de 30 de metri tot nu-ți găsești liniștea, nu mai e de la cameră.",
    "saying_en": "If you can't find peace in a 30-square-metre room, it's not the room.",
    "saying_it": "Se in una camera di 30 metri non trovi la pace, non è colpa della camera.",
    "desc_de": "Platz, Licht und ein Dachgeschoss so großzügig, dass du dich fragst, ob du nicht versehentlich ein kleines Apartment gebucht hast. Bett 180 × 200 cm, großzügige Dusche.",
    "desc_he": "מקום, אור ועליית גג כל כך מרווחת שתתהו אם לא הזמנתם בטעות דירה קטנה. מיטה 180 × 200 ס\"מ, מקלחת מרווחת.",
    "desc_pl": "Przestrzeń, światło i poddasze tak hojne, że zaczniesz się zastanawiać, czy przypadkiem nie zarezerwowałeś małego apartamentu. Łóżko 180 × 200 cm, przestronny prysznic.",
    "saying_de": "Wenn du in einem 30-Quadratmeter-Zimmer keine Ruhe findest, liegt es nicht am Zimmer.",
    "saying_he": "אם בחדר של 30 מ\"ר עדיין לא מצאת שקט — זה כבר לא בגלל החדר.",
    "saying_pl": "Jeśli w pokoju 30-metrowym nadal nie znajdziesz spokoju, to już nie wina pokoju.",
    "floor_de": "Dachgeschoss",
    "floor_he": "עליית גג",
    "floor_pl": "Poddasze",
    "view_de": "Innenhof",
    "view_he": "חצר",
    "view_pl": "Dziedziniec",
    "tag_ro": "Camera 3", "tag_en": "Room 3", "tag_de": "Zimmer 3", "tag_it": "Camera 3", "tag_he": "חדר 3", "tag_pl": "Pokój 3",
    "extras_ro": ["Fierbător, cafea și ceaiuri în cameră", "Prosoape și lenjerie albă incluse"],
    "extras_en": ["Kettle, coffee and teas in the room", "Towels and white linen included"],
    "extras_de": ["Wasserkocher, Kaffee und Tee im Zimmer", "Handtücher und weiße Bettwäsche inklusive"],
    "extras_it": ["Bollitore, caffè e tè in camera", "Asciugamani e biancheria bianca inclusi"],
    "extras_he": ["קומקום, קפה ותה בחדר", "מגבות ומצעים לבנים כלולים"],
    "extras_pl": ["Czajnik, kawa i herbata w pokoju", "Ręczniki i biała pościel w cenie"]
  },
  {
    "id": "room-nuc",
    "name_ro": "Camera Nuc",
    "name_en": "Walnut Room",
    "name_it": "Camera Noce",
    "slug": "camera-nuc",
    "type": "room",
    "base_price": 70,
    "capacity_adults": 2,
    "capacity_children": 1,
    "size": "30 m²",
    "floor_ro": "Mansardă",
    "floor_en": "Attic",
    "floor_it": "Mansarda",
    "bed": "180 × 200 cm",
    "shower": "cca. 100 × 170 cm",
    "view_ro": "Munte",
    "view_en": "Mountain",
    "view_it": "Montagna",
    "image": "/assets/bedroom.jpg",
    "active": true,
    "sort_order": 4,
    "desc_ro": "Caldă, liniștită și cu atmosfera aceea în care spui «stau cinci minute». După care trece o oră. Pat 180 × 200 cm, duș generos.",
    "desc_en": "Warm, quiet, with that atmosphere where you say 'just five more minutes' — and an hour goes by. 180 × 200 cm bed, generous shower.",
    "desc_it": "Calda, silenziosa, con quell'atmosfera in cui dici «solo cinque minuti» — e passa un'ora. Letto 180 × 200 cm, doccia ampia.",
    "saying_ro": "Patul e mare. Dacă tot te trezești pe margine, discută cu persoana de lângă tine, nu cu Mihai.",
    "saying_en": "The bed is huge. If you still wake up on the edge, talk to the person next to you, not to Mihai.",
    "saying_it": "Il letto è grande. Se ti svegli comunque sul bordo, parla con la persona accanto a te, non con Mihai.",
    "desc_de": "Warm, ruhig und mit dieser Atmosphäre, in der du sagst „nur noch fünf Minuten“ — und eine Stunde vergeht. Bett 180 × 200 cm, großzügige Dusche.",
    "desc_he": "חמים, שקט ועם האווירה ההיא שבה אומרים «עוד חמש דקות» — ועוברת שעה. מיטה 180 × 200 ס\"מ, מקלחת מרווחת.",
    "desc_pl": "Ciepły, cichy i z tą atmosferą, w której mówisz «jeszcze pięć minut» — i mija godzina. Łóżko 180 × 200 cm, przestronny prysznic.",
    "saying_de": "Das Bett ist riesig. Wenn du trotzdem am Rand aufwachst, sprich mit der Person neben dir, nicht mit Mihai.",
    "saying_he": "המיטה ענקית. אם בכל זאת התעוררת על הקצה, דבר עם מי שמלמדך, לא עם מיכאי.",
    "saying_pl": "Łóżko jest ogromne. Jeśli mimo to budzisz się na krawędzi, pogadaj z osobą obok, nie z Mihaiem.",
    "floor_de": "Dachgeschoss",
    "floor_he": "עליית גג",
    "floor_pl": "Poddasze",
    "view_de": "Berge",
    "view_he": "הרים",
    "view_pl": "Góry"
  },
  {
    "id": "private-house",
    "name_ro": "Imperfect Private House",
    "name_en": "Imperfect Private House",
    "name_it": "Imperfect Private House",
    "slug": "casa-intreaga",
    "type": "house",
    "base_price": 580,
    "capacity_adults": 8,
    "capacity_children": 4,
    "capacity_max": 12,
    "size": "160 m²",
    "floor_ro": "Parter + mansardă",
    "floor_en": "Ground floor + attic",
    "floor_it": "Piano terra + mansarda",
    "bed": "4 × 180 × 200 cm",
    "shower": "cca. 100 × 170 cm",
    "view_ro": "Grădină privată",
    "view_en": "Private garden",
    "view_it": "Giardino privato",
    "image": "/assets/garden-fire.jpg",
    "active": true,
    "sort_order": 5,
    "desc_ro": "Toată casa doar pentru voi: 4 camere cu băi proprii, living, bucătărie, balcon și grădina cu foc. Capacitate standard 8 persoane, extensibilă până la 12.",
    "desc_en": "The whole house just for you: 4 rooms with private bathrooms, living room, kitchen, balcony and the garden with the fire pit. Standard capacity 8 people, extendable up to 12.",
    "desc_it": "Tutta la casa solo per voi: 4 camere con bagno privato, soggiorno, cucina, balcone e giardino con braciere. Capacità standard 8 persone, estendibile fino a 12.",
    "saying_ro": "8 dorm ca boierii în cele patru paturi king-size. Pentru încă 4 oameni avem variante suplimentare (canapea și banchete cu saltele de cca. 200 × 80 cm). Nu le numim «king-size», că nici Creangă n-ar fi exagerat chiar așa.",
    "saying_en": "Eight sleep like barons in the four king-size beds. For 4 more people we have extra options (sofa and window benches with approx. 200 × 80 cm mattresses). We don't call them 'king-size' — even Creangă wouldn't exaggerate that much.",
    "saying_it": "In otto dormono da signori nei quattro letti king-size. Per altre 4 persone abbiamo soluzioni extra (divano e panchette con materassi di ca. 200 × 80 cm). Non le chiamiamo «king-size» — nemmeno Creangă avrebbe esagerato tanto.",
    "desc_de": "Das ganze Haus nur für euch: 4 Zimmer mit eigenen Bädern, Wohnzimmer, Küche, Balkon und der Garten mit der Feuerstelle. Standard 8 Personen, erweiterbar auf bis zu 12.",
    "desc_he": "כל הבית רק בשבילכם: 4 חדרים עם חדרי רחצה פרטיים, סלון, מטבח, מרפסת והגינה עם המדורה. תפוסה סטנדרטית 8 אנשים, ניתן להרחיב עד 12.",
    "desc_pl": "Cały dom tylko dla was: 4 pokoje z własnymi łazienkami, salon, kuchnia, balkon i ogród z ogniskiem. Standardowo 8 osób, z możliwością rozszerzenia do 12.",
    "saying_de": "Acht schlafen wie Barone in den vier King-Size-Betten. Für 4 weitere haben wir Zusatzlösungen (Sofa und Fensterbänke mit Matratzen ca. 200 × 80 cm). Wir nennen sie nicht „king-size“ — selbst Creangă hätte nicht so übertrieben.",
    "saying_he": "שמונה ישנים כמו בויארים בארבע מיטות הקינג-סייז. לעוד 4 יש לנו פתרונות נוספים (ספה וספסלי חלון עם מזרנים של כ-200 × 80 ס\"מ). לא נקרא להם «קינג-סייז» — גם קריאנגה לא היה מגזים ככה.",
    "saying_pl": "Ośmiu śpi jak bojarzy w czterech łóżkach king-size. Dla kolejnych 4 mamy rozwiązania dodatkowe (kanapa i ławy okienne z materacami ok. 200 × 80 cm). Nie nazywamy ich «king-size» — nawet Creangă by aż tak nie przesadzał.",
    "floor_de": "Erdgeschoss + Dachgeschoss",
    "floor_he": "קומת קרקע + עליית גג",
    "floor_pl": "Parter + poddasze",
    "view_de": "Privater Garten",
    "view_he": "גינה פרטית",
    "view_pl": "Ogród prywatny"
  }
];

export const REVIEWS = [
  {
    "id": "rev-alina",
    "guest_name": "Alina",
    "age": 26,
    "source": "Booking.com",
    "score": 9.0,
    "title": "Superb",
    "language": "en",
    "review_date": "2026-02-10",
    "approved": true,
    "featured": true,
    "text": "The house is newly refurbished with beautifully decorated rooms. A nice yard with seating and fire area where anyone can relax. The host, Mihai was very attentive and accommodating."
  },
  {
    "id": "rev-mari",
    "guest_name": "Mari B",
    "age": null,
    "source": "Google · Local Guide",
    "score": 10,
    "title": "Won our hearts from the first evening",
    "language": "en",
    "review_date": "2025-12-10",
    "approved": true,
    "featured": true,
    "text": "This place won our hearts from the first evening! A clean, chic, welcoming location, with a really good energy. We felt more like visiting friends than in an accommodation unit. The host is young, open, extremely friendly, and the evening was unforgettable: we played cards, socialized, told stories and had a drink together — a warm, family atmosphere, as you rarely find anymore. And the mornings… a real treat! Extraordinarily rich breakfast, with local, fresh and healthy products, prepared with love. I wholeheartedly recommend this place to everyone looking for more than just accommodation."
  },
  {
    "id": "rev-anca",
    "guest_name": "Anca",
    "age": 28,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "ro",
    "review_date": "2025-11-20",
    "approved": true,
    "featured": true,
    "text": "Ospitalitatea gazdei, Mihai, a fost excepțională — ne-a ajutat la orice cerință și ne-a făcut să ne simțim extrem de bine toată șederea. Camera și baia foarte curate, bucătăria comună full echipată, iar designul întregii cazări e funcțional și făcut cu mult gust: poți sta în curte la foc, să te uiți la un film pe videoproiector ori doar la o vorbă de seară cu prietenii. Locația e foarte bună, aproape de autobuzele spre Bran sau Brașov și de centru. Și doi căței drăgălași și cuminți, care ne-au oferit un sentiment de siguranță în fiecare seară. Recomandăm cu căldură familiilor, cuplurilor sau grupurilor de prieteni — noi sigur revenim!"
  },
  {
    "id": "rev-vasilache",
    "guest_name": "Vasilache",
    "age": 35,
    "source": "Booking.com",
    "score": 9.0,
    "title": "Superb",
    "language": "ro",
    "review_date": "2025-11-10",
    "approved": true,
    "featured": false,
    "text": "Camera mare, curățenia, disponibilitatea proprietarului."
  },
  {
    "id": "rev-pop",
    "guest_name": "Pop",
    "age": 42,
    "source": "Booking.com",
    "score": 10,
    "title": "Cazare foarte bună",
    "language": "ro",
    "review_date": "2025-11-08",
    "approved": true,
    "featured": false,
    "text": "Personal foarte amabil, camera foarte spațioasă, frumoasă și curată."
  },
  {
    "id": "rev-ema",
    "guest_name": "Ema",
    "age": null,
    "source": "Google",
    "score": 10,
    "title": "Cea mai frumoasă cazare din Râșnov",
    "language": "ro",
    "review_date": "2025-10-25",
    "approved": true,
    "featured": false,
    "text": "Cea mai frumoasă cazare din Râșnov, sunt sigură :) O gazdă mișto și 2 cățelușe iubitoare."
  },
  {
    "id": "rev-oana",
    "guest_name": "Oana",
    "age": 31,
    "source": "Booking.com",
    "score": 10,
    "title": "Perfect",
    "language": "ro",
    "review_date": "2025-09-18",
    "approved": true,
    "featured": true,
    "text": "Locul arată impecabil; funcțional, frumos, aerisit, spațios, curat. Patul a fost mare și confortabil, priveliștea minunată. Chiar ne-am simțit de parcă am mers în propria casă de vacanță. Impresionant."
  },
  {
    "id": "rev-marco",
    "guest_name": "Marco",
    "age": 34,
    "source": "Booking.com",
    "score": 10,
    "title": "Soggiorno perfetto",
    "language": "it",
    "review_date": "2025-09-05",
    "approved": true,
    "featured": false,
    "text": "Posto meraviglioso: camere spaziose, pulizia impeccabile e un host che ti fa sentire a casa. Il giardino con il falò serale è stato il nostro posto preferito. Torneremo sicuramente!"
  },
  {
    "id": "rev-ramona",
    "guest_name": "Ramona",
    "age": 33,
    "source": "Booking.com",
    "score": 10,
    "title": "Cozy and welcoming stay, great host!",
    "language": "en",
    "review_date": "2025-08-22",
    "approved": true,
    "featured": true,
    "text": "I spent a few wonderful days here with my 5-year-old son. The place is very cozy and comfortable, the room was spacious and welcoming. The host was extremely attentive: games for the child, a campfire in the evening, and even indoor or outdoor cinema depending on the weather. I warmly recommend!"
  },
  {
    "id": "rev-raluca",
    "guest_name": "Ioana-Raluca",
    "age": 36,
    "source": "Booking.com",
    "score": 10,
    "title": "Sejur relaxant în Râșnov",
    "language": "ro",
    "review_date": "2025-08-10",
    "approved": true,
    "featured": false,
    "text": "Camera extrem de spațioasă, patul foarte comod. Gazda a fost foarte prietenoasă și implicată. În ultima seară ne-a organizat un cinematograf afară pe terasă cu videoproiector — foarte drăguța idee. Recomandăm fără ezitare!"
  },
  {
    "id": "rev-carmen",
    "guest_name": "Carmen",
    "age": 27,
    "source": "Booking.com",
    "score": 10,
    "title": "Confort, liniște și gazde de nota 10",
    "language": "ro",
    "review_date": "2025-08-05",
    "approved": true,
    "featured": false,
    "text": "Un loc cozy și primitor, perfect pentru un weekend în Râșnov. Camera curată, decor modern, atmosferă caldă și o gazdă excepțională. Aproape de cetate și centru, dar suficient de liniștit pentru relaxare."
  },
  {
    "id": "rev-giulia",
    "guest_name": "Giulia",
    "age": 29,
    "source": "Google",
    "score": 10,
    "title": "Come a casa",
    "language": "it",
    "review_date": "2025-07-18",
    "approved": true,
    "featured": false,
    "text": "Accoglienza calorosa, colazione con prodotti locali e tanta quiete. La posizione è perfetta per visitare Bran e Brașov. Consigliatissimo!"
  },
  {
    "id": "rev-vlad",
    "guest_name": "Vlad",
    "age": 29,
    "source": "Booking.com",
    "score": 10,
    "title": "Liniște",
    "language": "ro",
    "review_date": "2025-06-14",
    "approved": true,
    "featured": true,
    "text": "Am stat 3 nopți cu un grup de prieteni și totul a fost absolut superb. Locație liniștită, decor cald, curățenie impecabilă. Am fost și cu un Shiba Inu de 4 luni — nimic de reproșat nici din punct de vedere pet friendly. O experiență 10/10!"
  },
  {
    "id": "rev-diana",
    "guest_name": "Diana",
    "age": 32,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "ro",
    "review_date": "2025-06-10",
    "approved": true,
    "featured": false,
    "text": "Locația foarte îngrijită și curată, amabilitatea și serviciile."
  },
  {
    "id": "rev-andrada",
    "guest_name": "Andrada",
    "age": 29,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "ro",
    "review_date": "2025-01-25",
    "approved": true,
    "featured": false,
    "text": "Totul a fost foarte frumos. Locația e situată într-o zonă bună și liniștită. Proprietarul ne-a ajutat cu tot ce am avut nevoie. Am fost împreună cu cățelușul nostru care a fost bine primit."
  },
  {
    "id": "rev-erik",
    "guest_name": "Erik",
    "age": 28,
    "source": "Booking.com",
    "score": 10,
    "title": "Great host!",
    "language": "en",
    "review_date": "2024-08-20",
    "approved": true,
    "featured": true,
    "text": "This is a great place to rest after a day of hiking, the rooms are great and the host is fantastic! All you need is within walking distance, and guests can cook together in a nice kitchen and eat in a modern, cozy space where you can make coffee or tea. A personal favourite: the house is formed so that you can enjoy the garden even when it rains — and there is a summer kitchen for optional barbeque evenings together. A big bonus: no need to worry about water quality, we drank straight from the tap. The host is a great guy, easy to talk with, with a good sense of humour — no language barrier for English speakers. I hope to get a room here again soon!"
  },
  {
    "id": "rev-tal",
    "guest_name": "Tal",
    "age": 29,
    "source": "Google",
    "score": 10,
    "title": "A home away from home",
    "language": "en",
    "review_date": "2026-07-02",
    "approved": true,
    "featured": true,
    "text": "We came from Israel for a week of hiking and this house became our favourite memory of Romania. Mihai welcomed us like old friends, the bed was super comfortable, and the evenings by the fire in the garden were pure magic. If you're travelling Transylvania, start here."
  },
  {
    "id": "rev-kasia",
    "guest_name": "Kasia",
    "age": 31,
    "source": "Booking.com",
    "score": 10,
    "title": "Wyjątkowe miejsce",
    "language": "pl",
    "review_date": "2026-07-21",
    "approved": true,
    "featured": false,
    "text": "Przyjechaliśmy z Krakowa na kilka dni w góry. Dom jest pięknie urządzony, pokój duży i czysty, a łóżko — najwygodniejsze, w jakim spaliśmy w Rumunii. Wieczorem ognisko w ogrodzie, rano kawa bez pośpiechu. Mihai polecił nam szlaki, o których nie piszą w przewodnikach. Wrócimy!"
  },
  {
    "id": "rev-ralu",
    "guest_name": "Ralu Lupu",
    "age": null,
    "source": "Google",
    "score": 10,
    "title": "Un anfitrión excepcional",
    "language": "es",
    "review_date": "2026-09-07",
    "approved": true,
    "featured": true,
    "text": "Hemos estado genial, Mihai es muy buen anfitrión, muy atento en todo momento y servicial. Habitaciones limpias, facilidad para cocinar tu propio desayuno, cena… Incluso nos regaló de sus productos ecológicos. ¡Volveremos seguro! ¡Gracias por todo!"
  },
  {
    "id": "rev-alexandru",
    "guest_name": "Alexandru Niculae",
    "age": null,
    "source": "Google",
    "score": 10,
    "title": "Gazdă foarte primitoare",
    "language": "ro",
    "review_date": "2025-12-05",
    "approved": true,
    "featured": false,
    "text": "Foarte frumos locul, gazda foarte primitoare și amabilă, iar la micul dejun ai produse tradiționale românești. Cu siguranță vom reveni!"
  },
  {
    "id": "rev-konstantin",
    "guest_name": "Konstantin Madrid",
    "age": null,
    "source": "Google",
    "score": 10,
    "title": "Cozy, quiet, unique",
    "language": "en",
    "review_date": "2025-09-05",
    "approved": true,
    "featured": false,
    "text": "Cozy… comfortable… quiet… unique… and amazing host! And two beautiful dogs. Rooms very clean — king size room, bed, bathroom. Nearby: Dino Parc, the bear sanctuary, Dracula's Castle, the aerodrome and many others."
  },
  {
    "id": "rev-drazv",
    "guest_name": "drazv",
    "age": null,
    "source": "Google",
    "score": 10,
    "title": "Ambient de boutique",
    "language": "ro",
    "review_date": "2025-09-10",
    "approved": true,
    "featured": false,
    "text": "Ambient de hotel boutique / casă de oaspeți, cu o gazdă implicată. Confort, curățenie, liniște. Recomand!"
  },
  {
    "id": "rev-ciprian",
    "guest_name": "Ciprian",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "ro",
    "review_date": "2026-08-22",
    "approved": true,
    "featured": false,
    "text": "Am fost plăcut surprins de proprietar și de cât de ospitalier a fost cu noi."
  },
  {
    "id": "rev-margarita",
    "guest_name": "Margarita",
    "age": null,
    "source": "Booking.com · Lituania",
    "score": 10,
    "title": "Absolutely recommended! Amazing place.",
    "language": "en",
    "review_date": "2026-08-08",
    "approved": true,
    "featured": true,
    "text": "Unique place, well thought out and very modern. Welcoming and helpful host, we felt like at a friend's house. Quiet and safe neighbourhood."
  },
  {
    "id": "rev-hildegard",
    "guest_name": "Hildegard",
    "age": null,
    "source": "Booking.com · Austria",
    "score": 10,
    "title": "The imperfect House is perfect!!!!",
    "language": "de",
    "review_date": "2026-07-28",
    "approved": true,
    "featured": true,
    "text": "Hotel-4-Sterne-Zimmer, sehr komfortabel, groß, sauber und modern. Besitzer nett und freundlich."
  },
  {
    "id": "rev-vladan",
    "guest_name": "Vladan",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "en",
    "review_date": "2026-07-22",
    "approved": true,
    "featured": false,
    "text": "Very nice host and location, big, clean and modern."
  },
  {
    "id": "rev-jorge",
    "guest_name": "Jorge",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Super",
    "language": "ro",
    "review_date": "2026-06-29",
    "approved": true,
    "featured": false,
    "text": "Servicii bune și liniște."
  },
  {
    "id": "rev-hanspeter",
    "guest_name": "Hans-Peter",
    "age": null,
    "source": "Booking.com · Germania",
    "score": 10,
    "title": "Wenn Râşnov — dann IMperfect!",
    "language": "de",
    "review_date": "2026-05-13",
    "approved": true,
    "featured": true,
    "text": "Insgesamt ruhiger Ort, von dem aus die umliegenden Ziele sehr leicht zu erreichen sind. Und ein Wald zum Spazierengehen direkt um die Ecke! Was für ein wohnlich gemütlicher Ort, der hier für die Gäste von Mihai geschaffen wurde! Sehr sympathischer Gastgeber, der immer ein paar Tipps parat hat — und das auch noch in fließendem Englisch, was nicht überall selbstverständlich ist. Auch beim Frühstück wurden uns alle Wünsche erfüllt! Wir waren mehrere Tage hier und können die Unterkunft nur wärmstens empfehlen!"
  },
  {
    "id": "rev-berna",
    "guest_name": "Berna",
    "age": null,
    "source": "Booking.com · Turcia",
    "score": 10,
    "title": "Her şey harikaydı",
    "language": "tr",
    "review_date": "2026-05-04",
    "approved": true,
    "featured": false,
    "text": "Otelin konumu Brașov'a çok yakın. Kargaşadan uzakta, dinginliğin içerisinde çok güzel bir tesis. Bölge güvenilir. Odalar ve tesis tamamen yenilenmiş, tavsiye ederim."
  },
  {
    "id": "rev-andreea-2026",
    "guest_name": "Andreea",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "ro",
    "review_date": "2026-04-15",
    "approved": true,
    "featured": false,
    "text": "O locație superbă și liniștitoare. Everything was perfect."
  },
  {
    "id": "rev-andreea-2025",
    "guest_name": "Andreea",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Very good",
    "language": "en",
    "review_date": "2025-11-11",
    "approved": true,
    "featured": false,
    "text": "Clean and quiet, the room was spacious, the dogs are lovely."
  },
  {
    "id": "rev-iulia",
    "guest_name": "Iulia",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "ro",
    "review_date": "2024-09-21",
    "approved": true,
    "featured": false,
    "text": "Totul fff bine!"
  },
  {
    "id": "rev-catalina",
    "guest_name": "Catalina",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Wonderful experience, very relaxing",
    "language": "en",
    "review_date": "2025-06-06",
    "approved": true,
    "featured": true,
    "text": "A very unique accommodation, under a new & modern concept: \"be a guest at my home\". The rooms are big, clean (spotless), modern, but at the same time you feel like you are at home. The owner is open, warm and accommodated all our requests (we have already been there twice). Very important: communicate your needs in advance (culinary preferences, allergies etc.), especially for breakfast, because it is prepared in an open kitchen, on the spot, with fresh ingredients."
  },
  {
    "id": "rev-dinu",
    "guest_name": "Dinu",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Very pleasant stay, awesome owner",
    "language": "en",
    "review_date": "2025-08-16",
    "approved": true,
    "featured": false,
    "text": "Everything was excellent! The host is a very nice person, focused on details and ready to help the guests. The house is recently renovated and you can see the touch of good taste. Hope to come back in autumn to explore more."
  },
  {
    "id": "rev-croitoru",
    "guest_name": "Croitoru",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Peaceful stay in Râşnov",
    "language": "en",
    "review_date": "2025-08-04",
    "approved": true,
    "featured": false,
    "text": "The room was big and spacious, very well-furnished. We loved the little, cosy bed in front of the window. It was very clean and very quiet. The location was close to the centre (15 min walk) and a supermarket (3 min). The host was very helpful and our daughter had a lot of fun with his two very friendly dogs."
  },
  {
    "id": "rev-stankova",
    "guest_name": "Станкова",
    "age": null,
    "source": "Booking.com · Bulgaria",
    "score": 10,
    "title": "Excepțional",
    "language": "bg",
    "review_date": "2025-08-01",
    "approved": true,
    "featured": false,
    "text": "Стаята е страхотна! Беше много чисто, удобно и комфортно. Господинът е много усмихнат и отзивчив! Мястото е близо до всичко за разходки!"
  },
  {
    "id": "rev-alexandru-iul",
    "guest_name": "Alexandru",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "en",
    "review_date": "2025-07-11",
    "approved": true,
    "featured": false,
    "text": "Even though the name of the house is Imperfect, everything we found here was perfect :) — from the host to the accommodation itself. Everything was very clean, the yard was very nice, we stayed in it almost the whole day. Very close to the city centre (10–15 min walk) and to some good restaurants."
  },
  {
    "id": "rev-meike",
    "guest_name": "Meike",
    "age": null,
    "source": "Booking.com · Germania",
    "score": 10,
    "title": "Moderne Ausstattung",
    "language": "de",
    "review_date": "2025-04-17",
    "approved": true,
    "featured": false,
    "text": "Die Unterkunft ist sehr zu empfehlen. Der eigene Bereich mit Bad und Wasserkocher ist sehr modern. Ich durfte die Waschmaschine benutzen, was sehr nett war. Der Hausherr war für alle Fragen und Ausflugstipps ein guter Ansprechpartner."
  },
  {
    "id": "rev-robert",
    "guest_name": "Robert",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Excelent!",
    "language": "en",
    "review_date": "2024-11-11",
    "approved": true,
    "featured": false,
    "text": "Great quiet location with free public parking in front of the building. The room was very large, the bed was great (king size), everything was spotless! In the last few years we stayed in Râșnov on 4–5 occasions in different places, and this stay was our most pleasant! We will definitely come back!"
  },
  {
    "id": "rev-nela",
    "guest_name": "Nela",
    "age": null,
    "source": "Booking.com · Cehia",
    "score": 10,
    "title": "Excepțional",
    "language": "en",
    "review_date": "2024-08-21",
    "approved": true,
    "featured": false,
    "text": "It was a fantastic stay. Mihai welcomed us like a friend and offered all kinds of extras. The house is nicely renovated and modern, and the bed is great!"
  },
  {
    "id": "rev-candau",
    "guest_name": "Candau",
    "age": null,
    "source": "Booking.com · Franța",
    "score": 10,
    "title": "Excepțional",
    "language": "fr",
    "review_date": "2024-08-17",
    "approved": true,
    "featured": false,
    "text": "L'accueil ! Le village ! La chambre ! Demandez ce que vous voulez et vous l'aurez. Tout parfait."
  },
  {
    "id": "rev-colomba",
    "guest_name": "Colomba",
    "age": null,
    "source": "Booking.com · Italia",
    "score": 10,
    "title": "Soggiorno molto piacevole in una struttura eccellente",
    "language": "it",
    "review_date": "2024-08-09",
    "approved": true,
    "featured": false,
    "text": "La struttura è completamente nuova, ottimo arredamento, letti molto comodi, stanze spaziose, giardino esterno con sdraio, tutto molto pulito, possibilità di usare la cucina. Il proprietario si è prodigato in ogni modo per farci sentire a nostro agio — una persona davvero ospitale e disponibile. Ottima posizione, molto vicina al centro storico di Râșnov."
  },
  {
    "id": "rev-alex",
    "guest_name": "Alex",
    "age": null,
    "source": "Booking.com",
    "score": 10,
    "title": "Excepțional",
    "language": "en",
    "review_date": "2024-08-04",
    "approved": true,
    "featured": false,
    "text": "Excellent stay in Râșnov. New, clean property with a great location. Easy walk to downtown and Râșnov Fortress. Comfortable rooms and nice common areas including a living room with bar and TV. Outdoor yard is a plus. Host Mihai is helpful and welcoming. Good value for money — recommended for Râșnov visitors."
  }
];

export const ATTRACTIONS = [
  {
    "id": "att-cetate",
    "name": "Cetatea Râșnov",
    "slug": "cetatea-rasnov",
    "categories": [
      "aproape",
      "castele",
      "saxon"
    ],
    "desc_ro": "Cetatea medievală care veghează orașul de când lumea. Când veneau vremuri rele, râșnovenii urcau aici — și uite-așa a rămas sus, să se uite peste oraș.",
    "desc_en": "The medieval fortress watching over the town since forever. When times got rough, the people of Râșnov climbed up here — which is why it still stands, looking down at the town.",
    "desc_it": "La fortezza medievale che veglia sulla città da sempre. Quando arrivavano tempi duri, la gente di Râșnov saliva qui — ed è per questo che è ancora lassù, a guardare la città.",
    "name_de": "Burg Râșnov (Rosenauer Burg)",
    "desc_de": "Die mittelalterliche Burg, die seit jeher über der Stadt wacht. Als die Zeiten rau wurden, stiegen die Rosenauer hier hinauf — deshalb steht sie noch heute da oben und schaut auf die Stadt herab.",
    "distance_km": 1.2,
    "travel_time": "5 min",
    "travel_approx": true,
    "lat": 45.5906,
    "lng": 25.4694,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://cetatearasnov.ro",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": true,
    "sort_order": 1,
    "last_verified": "2026-08-08",
    "source_name": "Rosenau Turism",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-dino",
    "name": "Dino Parc",
    "slug": "dino-parc",
    "categories": [
      "aproape",
      "copii"
    ],
    "desc_ro": "Dinozauri în mărime naturală, la câțiva pași de casă. Una dintre atracțiile principale pentru familii — energia copiilor, consumată elegant.",
    "desc_en": "Life-size dinosaurs, a few steps from the house. One of the main family attractions — the kids' energy, elegantly spent.",
    "desc_it": "Dinosauri a grandezza naturale, a pochi passi da casa. Una delle attrazioni principali per le famiglie — l'energia dei bambini, spesa con eleganza.",
    "desc_de": "Dinosaurier in Lebensgröße, nur wenige Schritte vom Haus. Eine der Hauptattraktionen für Familien — die Energie der Kinder, elegant verbraucht.",
    "distance_km": 1.7,
    "travel_time": "5 min",
    "travel_approx": true,
    "lat": 45.5928,
    "lng": 25.4708,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://dinoparc.ro",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "mixed",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": true,
    "sort_order": 2,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-magic-parc",
    "name": "Magic Parc",
    "slug": "magic-parc",
    "categories": [
      "aproape",
      "copii"
    ],
    "desc_ro": "Copilăria nu cere buletin: Mina de Aur, treasure hunt, spectacole de magie, castel gonflabil gigant, mini ATV și un univers fantasy pentru copii și adulți.",
    "desc_en": "Childhood needs no ID: the Gold Mine, treasure hunts, magic shows, a giant inflatable castle, mini ATVs and a fantasy world for kids and adults alike.",
    "desc_it": "L'infanzia non chiede documenti: la Miniera d'Oro, cacce al tesoro, spettacoli di magia, un castello gonfiabile gigante, mini ATV e un universo fantasy per bambini e adulti.",
    "desc_de": "Kindheit braucht keinen Ausweis: die Goldmine, Schatzsuchen, Zaubershows, eine riesige Hüpfburg, Mini-Quads und eine Fantasy-Welt für Kinder und Erwachsene.",
    "distance_km": 1.5,
    "travel_time": "5 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": "Strada Cetății 32, Râșnov",
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "mixed",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 3,
    "last_verified": "2026-08-08",
    "source_name": "Unde Mergem",
    "source_url": null,
    "admin_note": "Verificat programul înainte de vizită — sezonier."
  },
  {
    "id": "att-biserica-evanghelica",
    "name": "Biserica Evanghelică",
    "slug": "biserica-evanghelica",
    "categories": [
      "aproape",
      "history_faith",
      "saxon"
    ],
    "desc_ro": "Biserica comunității săsești, cu rădăcini în secolul al XIII-lea — elemente romanice, gotice și renascentiste. Cel mai important monument medieval al orașului după cetate.",
    "desc_en": "The Saxon community's church, rooted in the 13th century — Romanesque, Gothic and Renaissance elements. The town's most important medieval monument after the fortress.",
    "desc_it": "La chiesa della comunità sassone, con radici nel XIII secolo — elementi romanici, gotici e rinascimentali. Il più importante monumento medievale della città dopo la fortezza.",
    "name_de": "Evangelische Kirche",
    "desc_de": "Die Kirche der Sachsen-Gemeinde mit Wurzeln im 13. Jahrhundert — romanische, gotische und Renaissance-Elemente. Nach der Burg das bedeutendste mittelalterliche Denkmal der Stadt.",
    "distance_km": 0.8,
    "travel_time": "3 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "indoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 0,
    "active": true,
    "featured": false,
    "sort_order": 4,
    "last_verified": "2026-08-08",
    "source_name": "Rosenau Turism",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-biserica-sf-nicolae",
    "name": "Biserica Veche Sf. Nicolae",
    "slug": "biserica-sf-nicolae",
    "categories": [
      "aproape",
      "history_faith"
    ],
    "desc_ro": "Considerată cea mai veche biserică ortodoxă păstrată în elevație din sud-estul Transilvaniei. Un grafit din vechiul altar indică anul 1384.",
    "desc_en": "Considered the oldest Orthodox church preserved in elevation in south-eastern Transylvania. A graffito in the old altar points to the year 1384.",
    "desc_it": "Considerata la più antica chiesa ortodossa conservata in elevazione nel sud-est della Transilvania. Un graffito nell'altare antico indica l'anno 1384.",
    "name_de": "Alte Kirche St. Nikolaus",
    "desc_de": "Gilt als die älteste erhaltene orthodoxe Kirche im Südosten Siebenbürgens. Eine Ritzzeichnung im alten Altar weist auf das Jahr 1384.",
    "distance_km": 0.9,
    "travel_time": "3 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "indoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 0,
    "active": true,
    "featured": false,
    "sort_order": 5,
    "last_verified": "2026-08-08",
    "source_name": "Rosenau Turism",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-cumidava",
    "name": "Castrul Roman Cumidava",
    "slug": "cumidava",
    "categories": [
      "castele",
      "history_faith"
    ],
    "desc_ro": "Râșnovul de dinaintea Râșnovului. Cu aproape două milenii înainte de selfie-urile de la Bran, soldații Romei păzeau drumurile acestei regiuni.",
    "desc_en": "The Râșnov before Râșnov. Almost two millennia before the Bran selfies, Rome's soldiers were guarding the roads of this region.",
    "desc_it": "La Râșnov prima di Râșnov. Quasi due millenni prima dei selfie di Bran, i soldati di Roma sorvegliavano le strade di questa regione.",
    "name_de": "Römerkastell Cumidava",
    "desc_de": "Das Râșnov vor Râșnov. Fast zwei Jahrtausende vor den Bran-Selfies bewachten Roms Soldaten die Straßen dieser Region.",
    "distance_km": 2,
    "travel_time": "5 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 0,
    "active": true,
    "featured": false,
    "sort_order": 6,
    "last_verified": "2026-08-08",
    "source_name": "Rosenau Turism",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-pestera",
    "name": "Peștera Valea Cetății",
    "slug": "pestera-valea-cetatii",
    "categories": [
      "aproape",
      "natura"
    ],
    "desc_ro": "Peștera de la marginea orașului — scurtă, spectaculoasă și perfectă pentru o dimineață racoare.",
    "desc_en": "The cave at the edge of town — short, spectacular and perfect for a cool morning.",
    "desc_it": "La grotta ai margini della città — breve, spettacolare e perfetta per una mattina fresca.",
    "name_de": "Höhle Valea Cetății (Burgenthal-Höhle)",
    "desc_de": "Die Höhle am Stadtrand — kurz, spektakulär und perfekt für einen kühlen Vormittag.",
    "distance_km": 3,
    "travel_time": "10 min",
    "travel_approx": true,
    "lat": 45.5797,
    "lng": 25.4353,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "indoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 7,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-ursi",
    "name": "Rezervația de Urși Zărnești",
    "slug": "rezervatia-ursi",
    "categories": [
      "natura",
      "copii"
    ],
    "desc_ro": "Cea mai mare rezervație de urși bruni din Europa. Vecinii din pădure nu plătesc cazare — noi doar le vizităm casa.",
    "desc_en": "The largest brown bear sanctuary in Europe. The forest neighbours don't pay for accommodation — we're just visiting their home.",
    "desc_it": "La più grande riserva di orsi bruni d'Europa. I vicini della foresta non pagano l'alloggio — siamo noi a visitare casa loro.",
    "name_de": "Bärenreservat Zărnești",
    "desc_de": "Das größte Braunbären-Reservat Europas. Die Nachbarn aus dem Wald zahlen keine Übernachtung — wir besuchen nur ihr Zuhause.",
    "distance_km": 9,
    "travel_time": "15 min",
    "travel_approx": true,
    "lat": 45.5567,
    "lng": 25.3347,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://millionsoffriends.org",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": true,
    "sort_order": 8,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": "Vizite ghidate, cu programare."
  },
  {
    "id": "att-bran",
    "name": "Castelul Bran",
    "slug": "castelul-bran",
    "categories": [
      "castele",
      "dark"
    ],
    "desc_ro": "Istorie reală, regina Maria și legenda care a făcut Transilvania celebră. Istoria castelului într-o parte, Dracula în cealaltă — și suficientă ceață între ele încât fiecare să creadă ce vrea.",
    "desc_en": "Real history, Queen Marie and the legend that made Transylvania famous. The castle's history on one side, Dracula on the other — and enough fog in between for everyone to believe what they want.",
    "desc_it": "Storia vera, la regina Maria e la leggenda che ha reso famosa la Transilvania. La storia del castello da una parte, Dracula dall'altra — e abbastanza nebbia in mezzo perché ognuno creda a ciò che vuole.",
    "name_de": "Schloss Bran (Törzburg)",
    "desc_de": "Wahre Geschichte, Königin Marie und die Legende, die Siebenbürgen berühmt gemacht hat. Die Geschichte des Schlosses auf der einen Seite, Dracula auf der anderen — und genug Nebel dazwischen, damit jeder glauben darf, was er will.",
    "distance_km": 12,
    "travel_time": "20 min",
    "travel_approx": true,
    "lat": 45.5149,
    "lng": 25.3672,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://www.bran-castle.com",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": true,
    "sort_order": 9,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-cheile-rasnoavei",
    "name": "Cheile Râșnoavei",
    "slug": "cheile-rasnoavei",
    "categories": [
      "natura",
      "adrenalina"
    ],
    "desc_ro": "Aici nu vii doar pentru fotografie: trasee montane, alpinism, escaladă, călărie, tiroliană, bungee jumping și picnic. Ai venit să te odihnești? Excelent. Ai venit să sari de pe stâncă legat de o coardă? Și pentru tine avem program.",
    "desc_en": "You don't come here just for the photo: mountain trails, climbing, horse riding, zip line, bungee jumping and picnics. Came to rest? Excellent. Came to jump off a cliff tied to a rope? We have a program for you too.",
    "desc_it": "Non si viene qui solo per la foto: sentieri di montagna, arrampicata, equitazione, zip line, bungee jumping e picnic. Sei venuto a riposare? Ottimo. A saltare da una roccia legato a una corda? Abbiamo un programma anche per te.",
    "name_de": "Rosenauer Klamm (Cheile Râșnoavei)",
    "desc_de": "Hier kommt man nicht nur für das Foto her: Bergwege, Klettern, Reiten, Zipline, Bungee-Jumping und Picknick. Du willst dich ausruhen? Ausgezeichnet. Du willst an einem Seil gesichert vom Felsen springen? Auch dafür haben wir ein Programm.",
    "distance_km": 6,
    "travel_time": "15 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 3,
    "active": true,
    "featured": true,
    "sort_order": 10,
    "last_verified": "2026-08-08",
    "source_name": "Brasov Tourism",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-prapastii",
    "name": "Prăpăstiile Zărneștiului",
    "slug": "prapastiile-zarnestiului",
    "categories": [
      "natura"
    ],
    "desc_ro": "Canion spectaculos și unul dintre cele mai accesibile moduri de a intra în atmosfera Parcului Național Piatra Craiului.",
    "desc_en": "A spectacular canyon and one of the most accessible ways to step into the atmosphere of Piatra Craiului National Park.",
    "desc_it": "Un canyon spettacolare e uno dei modi più accessibili per entrare nell'atmosfera del Parco Nazionale Piatra Craiului.",
    "name_de": "Zărneșter Schlucht (Prăpăstiile Zărneștiului)",
    "desc_de": "Eine spektakuläre Schlucht und einer der einfachsten Wege, in die Atmosphäre des Nationalparks Piatra Craiului einzutauchen.",
    "distance_km": 12,
    "travel_time": "25 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 2,
    "active": true,
    "featured": false,
    "sort_order": 11,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-piatra-craiului",
    "name": "Piatra Craiului",
    "slug": "piatra-craiului",
    "categories": [
      "natura"
    ],
    "desc_ro": "Natura care nu are nevoie de Photoshop. Ursul, lupul, râsul și capra neagră erau aici cu mult înaintea noastră — peste 40% dintre speciile de mamifere ale României se întâlnesc în masiv.",
    "desc_en": "Nature that needs no Photoshop. The bear, the wolf, the lynx and the chamois were here long before us — over 40% of Romania's mammal species live in this massif.",
    "desc_it": "Natura che non ha bisogno di Photoshop. L'orso, il lupo, la lince e il camoscio erano qui molto prima di noi — oltre il 40% delle specie di mammiferi della Romania vive in questo massiccio.",
    "desc_de": "Natur, die kein Photoshop braucht. Bär, Wolf, Luchs und Gämse waren lange vor uns hier — über 40 % der Säugetierarten Rumäniens leben in diesem Massiv.",
    "distance_km": 15,
    "travel_time": "30 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://pcrai.ro",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 3,
    "active": true,
    "featured": true,
    "sort_order": 12,
    "last_verified": "2026-08-08",
    "source_name": "Parcul Național Piatra Craiului",
    "source_url": null,
    "admin_note": "Nu hrănim animalele, nu culegem plante din ariile protejate."
  },
  {
    "id": "att-pestera-magura",
    "name": "Peștera & Măgura",
    "slug": "pestera-magura",
    "categories": [
      "natura"
    ],
    "desc_ro": "Dealuri, gospodării, Bucegi într-o parte, Piatra Craiului în cealaltă. Unul dintre acele locuri unde telefonul devine inutil câteva minute — nicio fotografie nu arată exact ce vezi.",
    "desc_en": "Hills, farmsteads, the Bucegi on one side, Piatra Craiului on the other. One of those places where your phone becomes useless for a few minutes — no photo shows exactly what you see.",
    "desc_it": "Colline, fattorie, i Bucegi da una parte, il Piatra Craiului dall'altra. Uno di quei posti dove il telefono diventa inutile per qualche minuto — nessuna foto mostra esattamente ciò che vedi.",
    "desc_de": "Hügel, Gehöfte, das Bucegi-Massiv auf der einen, das Piatra-Craiului-Massiv auf der anderen Seite. Einer dieser Orte, an denen dein Handy für ein paar Minuten überflüssig wird — kein Foto zeigt genau das, was du siehst.",
    "distance_km": 14,
    "travel_time": "30 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 2,
    "active": true,
    "featured": false,
    "sort_order": 13,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-poiana-marului",
    "name": "Poiana Mărului",
    "slug": "poiana-marului",
    "categories": [
      "natura"
    ],
    "desc_ro": "Pentru drumuri liniștite, sate și peisaje fără aglomerația marilor obiective.",
    "desc_en": "For quiet roads, villages and landscapes without the crowds of the big attractions.",
    "desc_it": "Per strade tranquille, villaggi e paesaggi senza la folla delle grandi attrazioni.",
    "desc_de": "Für ruhige Straßen, Dörfer und Landschaften ohne die Menschenmassen der großen Attraktionen.",
    "distance_km": 22,
    "travel_time": "35 min",
    "travel_approx": true,
    "lat": 45.5976,
    "lng": 25.3045,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 14,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-sinca-veche",
    "name": "Șinca Veche",
    "slug": "sinca-veche",
    "categories": [
      "dark",
      "history_faith"
    ],
    "desc_ro": "Bisericile rupestre înconjurate de povești despre energii și dorințe. Le prezentăm ca ceea ce sunt: legende și folclor — frumoase, dar legende.",
    "desc_en": "Cave churches surrounded by stories of energies and wishes. We present them as what they are: legends and folklore — beautiful, but legends.",
    "desc_it": "Chiese rupestri circondate da storie di energie e desideri. Le presentiamo per quello che sono: leggende e folclore — belle, ma leggende.",
    "desc_de": "Felsenkirchen, umgeben von Geschichten über Energien und Wünsche. Wir erzählen sie als das, was sie sind: Legenden und Folklore — schön, aber Legenden.",
    "distance_km": 20,
    "travel_time": "30 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "mixed",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 15,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": "LEGENDĂ ≠ FAPT: marcat explicit ca folclor pe site."
  },
  {
    "id": "att-pietrele-solomon",
    "name": "Pietrele lui Solomon",
    "slug": "pietrele-solomon",
    "categories": [
      "dark",
      "natura"
    ],
    "desc_ro": "Natură, stâncă și legende la marginea Brașovului — locul unde junii coboară de fiecare dată cu povești noi.",
    "desc_en": "Nature, rock and legends at the edge of Brașov — where the Junii descend every year with new stories.",
    "desc_it": "Natura, roccia e leggende ai margini di Brașov — dove i Junii scendono ogni anno con nuove storie.",
    "name_de": "Salomons Felsen (Pietrele lui Solomon)",
    "desc_de": "Natur, Felsen und Legenden am Rande von Brașov — wo die Junii jedes Jahr mit neuen Geschichten herabsteigen.",
    "distance_km": 18,
    "travel_time": "30 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 16,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-padurea-sinca",
    "name": "Pădurea seculară Șinca",
    "slug": "padurea-sinca",
    "categories": [
      "dark",
      "natura"
    ],
    "desc_ro": "Pentru cei cărora misterul le place mai mult atunci când are câteva sute de ani și rădăcini adevărate.",
    "desc_en": "For those who like their mystery a few hundred years old, with real roots.",
    "desc_it": "Per chi preferisce il mistero vecchio di qualche secolo, con radici vere.",
    "name_de": "Urwald von Șinca",
    "desc_de": "Für alle, die ihr Geheimnis am liebsten ein paar hundert Jahre alt und mit echten Wurzeln mögen.",
    "distance_km": 18,
    "travel_time": "30 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 17,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-flightaddicted",
    "name": "FlightAddicted — zbor & aventură",
    "slug": "flightaddicted",
    "categories": [
      "adrenalina"
    ],
    "desc_ro": "Ieri ai văzut Branul de jos. Azi îl vezi de sus: zbor Râșnov–Bran, tur Postăvaru, tur Bucegi, parapantă, salt cu parașuta sau «pilot pentru o zi». Zborurile depind de vreme și programare.",
    "desc_en": "Yesterday you saw Bran from below. Today you see it from above: Râșnov–Bran flights, Postăvaru and Bucegi tours, paragliding, skydiving or 'pilot for a day'. Flights depend on weather and booking.",
    "desc_it": "Ieri hai visto Bran dal basso. Oggi la vedi dall'alto: volo Râșnov–Bran, tour Postăvaru e Bucegi, parapendio, lancio con paracadute o «pilota per un giorno». I voli dipendono dal meteo e dalla prenotazione.",
    "name_de": "FlightAddicted — Flug & Abenteuer",
    "desc_de": "Gestern hast du Bran von unten gesehen. Heute siehst du es von oben: Flüge Râșnov–Bran, Postăvaru- und Bucegi-Rundflüge, Paragliding, Fallschirmsprung oder „Pilot für einen Tag“. Die Flüge hängen von Wetter und Buchung ab.",
    "distance_km": 19,
    "travel_time": "25 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://flightaddicted.ro",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 3,
    "active": true,
    "featured": true,
    "sort_order": 18,
    "last_verified": "2026-08-08",
    "source_name": "flightaddicted.ro",
    "source_url": null,
    "admin_note": "Condiționat de meteo și programare prealabilă — CTA către site oficial."
  },
  {
    "id": "att-aventura",
    "name": "Aventura Parc Brașov",
    "slug": "aventura-parc",
    "categories": [
      "copii",
      "adrenalina"
    ],
    "desc_ro": "Trasee în copaci pentru toate vârstele și toate curajoasele. Bun și pentru zilele în care copiii au prea multă energie.",
    "desc_en": "Treetop trails for all ages and all levels of brave. Also good for days when the kids have too much energy.",
    "desc_it": "Percorsi sugli alberi per tutte le età e tutti i livelli di coraggio. Ottimo anche nei giorni in cui i bambini hanno troppa energia.",
    "desc_de": "Kletterparcours in den Bäumen für jedes Alter und jede Stufe von Mut. Auch gut an Tagen, an denen die Kinder zu viel Energie haben.",
    "distance_km": 23,
    "travel_time": "30 min",
    "travel_approx": true,
    "lat": 45.6162,
    "lng": 25.6089,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://aventuraparc.ro",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "mixed",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 2,
    "active": true,
    "featured": false,
    "sort_order": 19,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-mountain-coaster",
    "name": "Mountain Coaster Predeal",
    "slug": "mountain-coaster",
    "categories": [
      "copii",
      "adrenalina",
      "iarna"
    ],
    "desc_ro": "822 de metri de coborâre cu sănii de două locuri, prin pădure. Funcționează și vara, și iarna — adrenalină controlată, zâmbet garantat.",
    "desc_en": "822 metres of downhill on two-seat sleds, through the forest. Runs in summer and winter alike — controlled adrenaline, guaranteed grin.",
    "desc_it": "822 metri di discesa su slitte a due posti, attraverso la foresta. Funziona d'estate e d'inverno — adrenalina controllata, sorriso garantito.",
    "desc_de": "822 Meter Abfahrt auf Zweierschlitten durch den Wald. Läuft im Sommer wie im Winter — kontrollierter Adrenalinkick, Grinsen garantiert.",
    "distance_km": 16,
    "travel_time": "25 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 2,
    "active": true,
    "featured": false,
    "sort_order": 20,
    "last_verified": "2026-08-08",
    "source_name": "Predeal City App",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-poiana",
    "name": "Poiana Brașov",
    "slug": "poiana-brasov",
    "categories": [
      "iarna",
      "natura"
    ],
    "desc_ro": "Principalul domeniu schiabil al zonei: aprox. 24,5 km de pârtii, instalații pe cablu, restaurante și après-ski. Vara, drumeții și aer curat.",
    "desc_en": "The area's main ski domain: approx. 24.5 km of slopes, cable cars, restaurants and après-ski. In summer, hiking and clean air.",
    "desc_it": "Il principale comprensorio sciistico della zona: ca. 24,5 km di piste, impianti di risalita, ristoranti e après-ski. D'estate, escursioni e aria pulita.",
    "desc_de": "Das wichtigste Skigebiet der Region: ca. 24,5 km Pisten, Seilbahnen, Restaurants und Après-Ski. Im Sommer Wandern und frische Luft.",
    "distance_km": 15,
    "travel_time": "25 min",
    "travel_approx": true,
    "lat": 45.5956,
    "lng": 25.5527,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://poiana-brasov.com",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 2,
    "active": true,
    "featured": true,
    "sort_order": 21,
    "last_verified": "2026-08-08",
    "source_name": "Poiana Brașov",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-predeal",
    "name": "Predeal — Clăbucet",
    "slug": "predeal",
    "categories": [
      "iarna"
    ],
    "desc_ro": "Schi, snowboard, școli de schi, închirieri și pârtii iluminate — la o distanță la care meriți să pleci după micul dejun.",
    "desc_en": "Skiing, snowboarding, ski schools, rentals and floodlit slopes — close enough to leave right after breakfast.",
    "desc_it": "Sci, snowboard, scuole di sci, noleggi e piste illuminate — abbastanza vicino per partire subito dopo colazione.",
    "desc_de": "Ski, Snowboard, Skischulen, Verleih und beleuchtete Pisten — nah genug, um gleich nach dem Frühstück loszufahren.",
    "distance_km": 16,
    "travel_time": "25 min",
    "travel_approx": true,
    "lat": 45.5047,
    "lng": 25.5783,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "winter",
    "indoor_outdoor": "outdoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 2,
    "active": true,
    "featured": false,
    "sort_order": 22,
    "last_verified": "2026-08-08",
    "source_name": "Predeal City App",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-cheile-gradistei",
    "name": "Cheile Grădiștei — Fundata & Moieciu",
    "slug": "cheile-gradistei",
    "categories": [
      "iarna",
      "copii"
    ],
    "desc_ro": "Trei pârtii pentru începători și intermediari, zăpadă artificială, închirieri și tubing. Prietenos cu cei mici și cu cei la prima zăpadă.",
    "desc_en": "Three slopes for beginners and intermediates, artificial snow, rentals and tubing. Friendly for kids and first-time snow.",
    "desc_it": "Tre piste per principianti e intermedi, neve artificiale, noleggi e tubing. Ideale per bambini e per la prima neve.",
    "desc_de": "Drei Pisten für Anfänger und Fortgeschrittene, Kunstschnee, Verleih und Tubing. Freundlich zu den Kleinen und zum ersten Schnee.",
    "distance_km": 25,
    "travel_time": "35 min",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://cheilegradistei.ro",
    "phone": null,
    "season": "winter",
    "indoor_outdoor": "outdoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 23,
    "last_verified": "2026-08-08",
    "source_name": "Cheile Gradistei",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-cantacuzino",
    "name": "Castelul Cantacuzino, Bușteni",
    "slug": "castelul-cantacuzino",
    "categories": [
      "castele"
    ],
    "desc_ro": "Arhitectură, artă și priveliște către Bucegi — castelul care a convins și Netflix.",
    "desc_en": "Architecture, art and a view of the Bucegi — the castle that convinced even Netflix.",
    "desc_it": "Architettura, arte e vista sui Bucegi — il castello che ha convinto persino Netflix.",
    "name_de": "Schloss Cantacuzino, Bușteni",
    "desc_de": "Architektur, Kunst und der Blick aufs Bucegi-Massiv — das Schloss, das sogar Netflix überzeugt hat.",
    "distance_km": 35,
    "travel_time": "45 min",
    "travel_approx": true,
    "lat": 45.4097,
    "lng": 25.5373,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 24,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-peles",
    "name": "Castelul Peleș, Sinaia",
    "slug": "castelul-peles",
    "categories": [
      "castele"
    ],
    "desc_ro": "Una dintre cele mai spectaculoase reședințe regale din Europa de Est. Mergi devreme — frumusețea asta e foarte populară.",
    "desc_en": "One of the most spectacular royal residences in Eastern Europe. Go early — this kind of beauty is very popular.",
    "desc_it": "Una delle residenze reali più spettacolari dell'Europa dell'Est. Vai presto — questa bellezza è molto popolare.",
    "name_de": "Schloss Peleș, Sinaia",
    "desc_de": "Eine der spektakulärsten königlichen Residenzen Osteuropas. Geh früh hin — diese Schönheit ist sehr beliebt.",
    "distance_km": 45,
    "travel_time": "55 min",
    "travel_approx": true,
    "lat": 45.3599,
    "lng": 25.5426,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": "https://peles.ro",
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": true,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 25,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-feldioara",
    "name": "Feldioara / Marienburg",
    "slug": "feldioara",
    "categories": [
      "castele",
      "saxon"
    ],
    "desc_ro": "Fortificația asociată istoriei Cavalerilor Teutoni — prima oprire dacă vrei să înțelegi cum a început Transilvania săsească.",
    "desc_en": "The fortress linked to the history of the Teutonic Knights — the first stop if you want to understand how Saxon Transylvania began.",
    "desc_it": "La fortezza legata alla storia dei Cavalieri Teutonici — la prima tappa se vuoi capire come è nata la Transilvania sassone.",
    "desc_de": "Die Festung, die mit der Geschichte des Deutschen Ordens verbunden ist — der erste Halt, wenn du verstehen willst, wie das siebenbürgisch-sächsische Land begann.",
    "distance_km": 25,
    "travel_time": "30 min",
    "travel_approx": true,
    "lat": 45.8203,
    "lng": 25.5958,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 26,
    "last_verified": "2026-08-08",
    "source_name": "Rosenau Turism",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-harman",
    "name": "Hărman / Honigberg",
    "slug": "harman",
    "categories": [
      "castele",
      "saxon",
      "history_faith"
    ],
    "desc_ro": "Biserică fortificată săsească cu origini medievale — ziduri, turnuri și liniște de altădată.",
    "desc_en": "A Saxon fortified church with medieval origins — walls, towers and the quiet of another time.",
    "desc_it": "Chiesa fortificata sassone di origine medievale — mura, torri e la quiete di un altro tempo.",
    "desc_de": "Sächsische Kirchenburg mit mittelalterlichen Wurzeln — Mauern, Türme und die Stille einer anderen Zeit.",
    "distance_km": 20,
    "travel_time": "25 min",
    "travel_approx": true,
    "lat": 45.7153,
    "lng": 25.6864,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 27,
    "last_verified": "2026-08-08",
    "source_name": "Rosenau Turism",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-prejmer",
    "name": "Prejmer / Tartlau",
    "slug": "prejmer",
    "categories": [
      "castele",
      "saxon",
      "history_faith"
    ],
    "desc_ro": "Una dintre marile biserici fortificate ale Transilvaniei, parte din patrimoniul UNESCO. Zidurile astea au văzut tot.",
    "desc_en": "One of Transylvania's great fortified churches, part of the UNESCO heritage. These walls have seen it all.",
    "desc_it": "Una delle grandi chiese fortificate della Transilvania, patrimonio UNESCO. Queste mura hanno visto tutto.",
    "desc_de": "Eine der großen Kirchenburgen Siebenbürgens, Teil des UNESCO-Welterbes. Diese Mauern haben alles gesehen.",
    "distance_km": 28,
    "travel_time": "35 min",
    "travel_approx": true,
    "lat": 45.7217,
    "lng": 25.7733,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": false,
    "sort_order": 28,
    "last_verified": "2026-08-08",
    "source_name": "Rosenau Turism",
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-saxon-day",
    "name": "THE SAXON DAY — circuit",
    "slug": "the-saxon-day",
    "categories": [
      "saxon",
      "castele"
    ],
    "desc_ro": "Rosenau → Honigberg → Tartlau → Marienburg → Kronstadt. O zi prin Transilvania germană: Râșnov, Hărman, Prejmer, Feldioara și Brașov, cu moștenirea săsească încă vizibilă în arhitectură și fortificații.",
    "desc_en": "Rosenau → Honigberg → Tartlau → Marienburg → Kronstadt. A day through German Transylvania: Râșnov, Hărman, Prejmer, Feldioara and Brașov, with the Saxon heritage still visible in architecture and fortifications.",
    "desc_it": "Rosenau → Honigberg → Tartlau → Marienburg → Kronstadt. Un giorno attraverso la Transilvania tedesca: Râșnov, Hărman, Prejmer, Feldioara e Brașov, con l'eredità sassone ancora visibile nell'architettura e nelle fortificazioni.",
    "desc_de": "Rosenau → Honigberg → Tartlau → Marienburg → Kronstadt. Ein Tag durch das deutsche Siebenbürgen: Râșnov, Hărman, Prejmer, Feldioara und Brașov — mit dem sächsischen Erbe, das in Architektur und Wehrbauten noch sichtbar ist.",
    "distance_km": 0,
    "travel_time": "1 zi",
    "travel_approx": true,
    "lat": null,
    "lng": null,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": true,
    "sort_order": 29,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": "Circuit propriu — Mihai ajută la organizare."
  },
  {
    "id": "att-brasov",
    "name": "Brașov / Kronstadt",
    "slug": "brasov",
    "categories": [
      "nightlife",
      "solo",
      "taste",
      "saxon"
    ],
    "desc_ro": "Centrul Vechi compact: puburi, cocktail bars, live music, rock și nopți cu DJ. Ziua vezi Transilvania — noaptea îi cunoști oamenii.",
    "desc_en": "A compact Old Town: pubs, cocktail bars, live music, rock and DJ nights. By day you see Transylvania — by night you meet its people.",
    "desc_it": "Un centro storico compatto: pub, cocktail bar, musica dal vivo, rock e serate DJ. Di giorno vedi la Transilvania — di notte conosci la sua gente.",
    "desc_de": "Eine kompakte Altstadt: Pubs, Cocktailbars, Livemusik, Rock und DJ-Nächte. Tagsüber siehst du Siebenbürgen — nachts lernst du seine Menschen kennen.",
    "distance_km": 17,
    "travel_time": "25 min",
    "travel_approx": true,
    "lat": 45.6427,
    "lng": 25.5887,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 1,
    "active": true,
    "featured": true,
    "sort_order": 30,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  },
  {
    "id": "att-aeroport",
    "name": "Aeroportul Brașov-Ghimbav",
    "slug": "aeroport",
    "categories": [
      "aproape"
    ],
    "desc_ro": "Aeroportul internațional al zonei — la 25 de minute de casă. Transferul se poate organiza la cerere.",
    "desc_en": "The area's international airport — 25 minutes from the house. Transfers can be arranged on request.",
    "desc_it": "L'aeroporto internazionale della zona — a 25 minuti da casa. Transfer organizzabile su richiesta.",
    "name_de": "Flughafen Brașov-Ghimbav",
    "desc_de": "Der internationale Flughafen der Region — 25 Minuten vom Haus. Transfers können auf Anfrage organisiert werden.",
    "distance_km": 19,
    "travel_time": "25 min",
    "travel_approx": true,
    "lat": 45.7056,
    "lng": 25.5228,
    "photo": null,
    "address": null,
    "maps_url": null,
    "website": null,
    "phone": null,
    "season": "all",
    "indoor_outdoor": "outdoor",
    "kids": false,
    "couples": true,
    "solo": true,
    "adventure": 0,
    "active": true,
    "featured": false,
    "sort_order": 40,
    "last_verified": "2026-08-08",
    "source_name": null,
    "source_url": null,
    "admin_note": null
  }
];

// Perioade OCUPATE per unitate (editezi manual sau la cerere).
// Exemplu: "room-crem": ["2026-08-10/2026-08-14"]
export const BOOKED = {
  "room-crem": [],
  "room-salvie": [],
  "room-teracota": [],
  "room-nuc": [],
  "private-house": [],
};

// Reguli optionale de pret (weekend vs. weekday) si minim de nopti.
// Lasă gol pentru pret de baza peste tot.
export const PRICING_RULES = [
  // Exemplu:
  // { unit_id: null, start_date: "2026-07-01", end_date: "2026-08-31",
  //   price_weekday: 70, price_weekend: 85, minimum_nights: 2 },
];

// ---------- helperi (nu edita) ----------
const inRange = (d, s, e) => d >= s && d < e;

export const dayStatus = (unitId, ds, todayIso, bookedMap = BOOKED) => {
  if (ds < todayIso) return "past";
  for (const r of bookedMap[unitId] || []) {
    const [s, e] = r.split("/");
    if (inRange(ds, s, e)) return "booked";
  }
  return "available";
};

export const nightlyPrice = (unit, ds) => {
  const wd = new Date(ds + "T12:00:00").getDay(); // 0=Du .. 6=Sa
  for (const r of PRICING_RULES) {
    if (r.unit_id && r.unit_id !== unit.id) continue;
    if (ds >= r.start_date && ds <= r.end_date) {
      if ((wd === 5 || wd === 6) && r.price_weekend) return r.price_weekend;
      if (r.price_weekday) return r.price_weekday;
    }
  }
  return unit.base_price;
};

export const minNightsFor = (unit, ci, co) => {
  let mn = 1;
  const d = new Date(ci + "T12:00:00");
  const end = new Date(co + "T12:00:00");
  while (d < end) {
    const ds = d.toISOString().slice(0, 10);
    for (const r of PRICING_RULES) {
      if (r.unit_id && r.unit_id !== unit.id) continue;
      if (ds >= r.start_date && ds <= r.end_date && r.minimum_nights)
        mn = Math.max(mn, r.minimum_nights);
    }
    d.setDate(d.getDate() + 1);
  }
  return mn;
};
